
/**
 * @class Readdress
 */
var Readdress = (function () {
    /**
     * @var Readdress
     */
    var self;

    return {
        config: {
            readdressingBlockClass: '.readdressing-block',
            readdressingOverflowClass: '.readdressing-overflow',
        },
        vars: {},

        init: function (config) {
            self = this;
            let isMobile = DetectMobile.isMobileListener();
            self.initVars();

            if (document.querySelector(self.config.readdressingBlockClass)) {
                self.readdressingBlockInit();
            }
            // console.log('Init');
        },

        initVars: function () {
            self.vars = {
                isMobile: DetectMobile.isMobileListener(),
                scrollTop: 0,
                readdressingBlock: $(self.config.readdressingBlockClass),
                readdressingOverflow: $(self.config.readdressingOverflowClass),
            };
        },
        readdressingBlockInit: function() {
            let readdressingUrl = self.vars.readdressingBlock.attr('data-url');
            let image_h = $('.readdress-image-link').outerHeight();
            let w_height = $(window).height();
            $('html, body').animate({ scrollTop: 0 }, 0);
            let redirection = true;
            let readdressingBlockPos = Math.round(self.vars.readdressingBlock.offset().top);
            let r_timer;
            let i = 0;
            $(window).scroll(function() {
                if (redirection) {
                    let currentScrollTopPos = Math.round(window.pageYOffset);
                    let currentScrollPos = Math.round((window.pageYOffset + window.innerHeight));
                    if (currentScrollPos > readdressingBlockPos) {

                        r_timer = window.setTimeout(function(){
                            if (i === 0) {
                                window.dataLayer.push({'event': 'scrolltosite'})
                                i = 1;
                            }
                            $(location).attr('href', readdressingUrl);
                        }, 2000);

                        $('html, body').animate({ scrollTop: currentScrollTopPos }, 0);
                    } else {
                        window.clearTimeout(r_timer);
                    }
                }
            });
        },
    }
})();

/**
 * @var ScrollEvents
 */
var ScrollEvents = (function () {
    /**
     * @var ScrollEvents
     */
    var self = this;

    return {
        config: {
            parallaxItemClass: '.js-header-parallax',
            parallaxItemSpeedDataAttr: 'speed-scroll',
            parallaxSpeed: ''
        },
        vars: {
        },
        init: function (config) {
            self = this;
            self.initVars();
            self.smoothScrollClick();
            self.pagination();
            // self.imageParalax();
            // console.log('ScrollEvents init');
        },
        initVars: function () {
            self.vars = {
                parallaxItem: $(self.config.parallaxItemClass),
                firstInit: true,
                goodsElmPosition: [],
                iteration: true
            }
        },
        smoothScrollClick: function(elm) {
            $(document).on('click', 'a[href^="#"]', function (event) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: $($.attr(this, 'href')).offset().top
                }, 800);

            });
        },
        smoothScroll: function(elm) {
            $('html, body').animate({
                scrollTop: elm.offset().top
            }, 800);
        },
        pagination: function() {
            $('.pagination').fadeOut();
            let delta= $(window).height() / 3;
            function checkViewport() {
                let currentPageNumber = 0;
                $('.section').each(function(index){
                    if ($(this).data('page') !== undefined) {
                        if ($(document).scrollTop() >= $(this).offset().top - delta && $(document).scrollTop() <=  $(this).offset().top + $(this).outerHeight(true)) {
                            $('[class*="product-"]').removeClass('active');
                            $(this).addClass('active');
                           currentPageNumber = $(this).data('page');
                        }
                    }
                })
                return currentPageNumber;
            }
            $(document).scroll(function(){
                let curActivePage = checkViewport();
                if (curActivePage > 0) {
                    $('.pagination li').removeClass('active');
                    $('.pagination').find('.page-' + curActivePage).addClass('active');
                } else {
                    $('.pagination li').removeClass('active');
                }
                if ($(document).scrollTop() > $('section.main').outerHeight(true) / 1.5) {
                    $('.pagination').fadeIn();
                } else {
                    $('.pagination').fadeOut();
                }
            })

            $('.pagination li').on('click', function(){
                let curPage = $(this).data('target');
                self.smoothScroll($('[data-page="' + curPage +'"]'));
            })
        },
        imageParalax: function(){
            let imgParallax = $('.products-widget .products-widget__image')
            let dilimeter = 100;
            imgParallax.on('mousemove', function(e){
                var rect = e.target.getBoundingClientRect();
                var xWidth = $(this).find('img').width();
                var yHeight = $(this).find('img').height();
                var x = e.clientX - rect.left;
                var y = e.clientY - rect.top;
                console.log(x, xWidth * 0.4)
                if (x <= xWidth * 0.4) {
                    $(this).find('img').css({
                        "transform": "translate(0, -50%)",
                        'transform-origin': 'center left',
                        "left" : -20 + 'px'
                    });
                }
                // if (y <= yHeight * 0.4) {
                //     $(this).find('img').css({
                //         "transform": "translate(-50%, 0)",
                //         'transform-origin': 'center left',
                //         "top" : -20 + 'px'
                //     });
                // }


            });
            imgParallax.mouseleave(function(e){
                $('.products-widget .products-widget__image').each(function(index){
                    $(this).find('img').css({
                        "transform": "translate(-50%, -50%)",
                        'transform-origin': 'center center',
                        "left": 50 + '%',
                        "top": 50 + '%'
                    });
                })
            })
        }
    }
})();

/**
 * @var Slider
 * @type {{config, vars, init, initVars, Slider}}
 */
var Slider = (function () {
    /**
     * @var Slider
     */
    var self = this;

    return {
        config: {
            cardsSliderClass: '.card-slider',
            textSliderClass: '.text-slider'

        },
        vars: {},
        init: function (config) {
            self = this;
            self.initVars();
            self.swiper();
            self.textSwiper();
            self.verticalSwiper();
            // console.log('MainSlider init');
        },
        initVars: function () {
            self.vars = {
                cardsSlider: $(self.config.cardsSliderClass),
                textSlider: $(self.config.textSliderClass),
            }
        },
        swiper: function() {
            self.vars.cardsSlider.each(function(index, value){
                var mySwiper = new Swiper(value, {
                    slidesPerView: 'auto',
                    spaceBetween: 34,
                    loop: true,
                    speed: 1200,
                    delay: 500,
                    breakpoints: {
                        // when window width is >= 320px
                        320: {
                            spaceBetween: 20,
                            freeMode: {
                                enabled: true,
                                sticky: true,
                            },
                        },
                        768: {
                            spaceBetween: 34,
                            freeMode: {
                                enabled: false,
                                sticky: false,
                            },
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
            });
        },
        textSwiper: function() {
            self.vars.textSlider.each(function(index, value){
                let idx = $(this).attr('id');
                var mySwiper = new Swiper(value, {
                    slidesPerView: 1,
                    spaceBetween: 14,
                    speed: 1800,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    breakpoints: {
                        // when window width is >= 320px
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                            speed: 800,
                            effect: 'fade',
                            fadeEffect: {
                                crossFade: true
                            },
                        },
                        768: {
                            effect: 'fade',
                            speed: 1800,
                            fadeEffect: {
                                crossFade: true
                            },
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                    },
                });
            });
        },
        verticalSwiper: function() {
            var vSwiper = new Swiper('.vertical-swiper', {
                direction: 'vertical',
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: 20,
                preventClicks :true,
                a11y: false,
                mousewheel: true,
                speed: 5000,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: true,
                    pauseOnMouseEnter: true,
                },
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 'auto',
                        spaceBetween: 10,
                        direction: 'horizontal',
                    },
                    768: {
                        slidesPerView: 'auto',
                        spaceBetween: 10,
                        direction: 'horizontal',
                    },
                    1024: {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                        direction: 'vertical',
                    }
                },
            });
        }
    }
})();

/**
 * @class StarsSpace
 */
const StarsSpace = (function () {
    /**
     * @var StarsSpace
     */
    let self;

    return {
        config: {
        },
        init: function (config) {
            self = this;
            self.initVars();
            self.fadeZodiak();
            self.animateStars();

        },
        initVars: function () {
            self.vars = {
                isMobile: DetectMobile.isMobileListener(),
            }
        },
        fadeZodiak: function() {
            let zodiakItem = $(".zodiak-item");
            let count = 0
            zodiakItem.each(function(index) {
                let rnd = Math.floor((Math.random() + 1) * 30);
                count++;
                $(this).stop(true, true).delay(rnd + '0').animate({transform: 1},

                {
                    easing: 'linear',
                    step: function (now, fx) {
                        $(this).css('transform', 'scale(1)');
                        if (count === 12) {
                            $('.main').addClass('active');
                            self.animateZodiak();
                        }
                    }
                })
            })

        },
        animateStars: function () {
            let sky, center
            function dot(i) {
                const size = Math.round(Math.random() + 1)
                const root = document.createElement('span')
                root.style.top = center.y + 'px'
                root.style.left = center.x + 'px'
                root.classList.add('star', `size-${size}`, `axis-${i}`)
                return root
            }

            function clear() {
                sky.innerHTML = ''
            }

            function init() {
                sky = document.querySelector('#sky')
                center = {
                    x: sky.clientWidth / 2,
                    y: sky.clientHeight / 2,
                }
                clear()
                for (let i = 0; i < 360; i++) sky.appendChild(dot(i))
            }

            window.onload = init
        },
        animateZodiak: function() {
            let zodiakWrapper = $(document).find(".main.active");
            var relX, relY;
            zodiakWrapper.on('mousemove', function(e){
                relX = Math.min(e.pageX);
                relY = Math.min(e.pageY);
                $('.zodiak-item').each(function(){
                    var parentOffset = $(this).offset();
                    let dilimeter = 20;
                    let posItem = $(this).position();
                    let delta = parentOffset.left / parentOffset.top;
                    $(this).css({"transform": "translate3d("+ (posItem.left - relX + delta) / dilimeter + "px, " + (posItem.top - relY + delta) / dilimeter + "px, 0px)"});

                });
            });
            zodiakWrapper.mouseleave(function(e){
                $('.zodiak-item').each(function(index){
                    $(this).css({"transform": "translate3d("+ 0 + "px, " + 0 + "px, 0px)"});
                })
            })
        }
    }
})();

/**
 * @class viewportChecker
 */
const viewportChecker = (function () {
    /**
     * @var viewportChecker
     */
    let self;

    return {
        config: {
            animateItemClass: '.animate-block'
        },
        init: function (config) {
            self = this;
            self.initVars();
            self.animateCSS();
        },
        initVars: function () {
            self.vars = {
                isMobile: DetectMobile.isMobileListener(),
                animateItem: $(self.config.animateItemClass)
            }
        },
        animateCSS: function () {
            // console.log( self.vars.isMobile);
            $(self.vars.animateItem).viewportChecker({
                classToRemove: 'invisible',
                offset: self.vars.isMobile ? 0 : 50,
            });
        },
    }
})();

/**
 * @class DetectMobile
 */
const DetectMobile = (function () {
    /**
     * @var DetectMobile
     */
    var self;

    return {
        config: {
            responsClass: $('html'),
            isMobile: false
        },

        vars: {},

        init: function (config) {
            self = this;
            self.isMobileListener();
            self.responseClass();
        },
        isMobileListener: function () {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
                DetectMobile.config.isMobile = true;
                return DetectMobile.config.isMobile;
            } else {
                return false;
            }

        },
        responseClass: function() {
            $(window).on('load resize', function(){
                if($(window).width() > 1280) {
                    self.config.responsClass.addClass('desktop');
                } else {
                    self.config.responsClass.removeClass('desktop');
                }

                if($(window).width() <= 1280 && $(window).width() >= 1024) {
                    self.config.responsClass.addClass('ipad');
                } else {
                    self.config.responsClass.removeClass('ipad');
                }

                if($(window).width() <= 1023 && $(window).width() >= 768) {
                    self.config.responsClass.addClass('tablet');
                } else {
                    self.config.responsClass.removeClass('tablet');
                }

                if($(window).width() <= 767) {
                    self.config.responsClass.addClass('mobile');
                } else {
                    self.config.responsClass.removeClass('mobile');
                }
            });
        },
    }
})();

/**
 * @class DefaultPage
 */
var DefaultPage = (function () {
    /**
     * @var DefaultPage
     */
    var self;

    return {
        init: function () {
            self = this;
            DetectMobile.init();
            ScrollEvents.init();
            StarsSpace.init();
            Slider.init();
            viewportChecker.init();
            Readdress.init();
            // console.log('DefaultPage init');
        }
    }
})();

